import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-l1-device-list",
  "use": "icon-soc-l1-device-list-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-l1-device-list\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\">\r\n  <path d=\"M160 192h224v640H160V192zm64 64v512h96V256h-96z\" />\r\n  <path d=\"M448 192h224v640H448V192zm64 64v512h96V256h-96z\" />\r\n  <path d=\"M736 192h128v640H736V192zm32 64v512h64V256h-64z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-l1-device-list.svg
// module id = 9qjB
// module chunks = 477